import { createContext, useContext, useState } from "react";

export const STR = {
  en: {
    navHome: "Home", navRates: "Live Rates", navCharts: "Charts", navMetals: "Metals", navProducts: "Products", navLocation: "Location", navContact: "Contact",
    heroBadge: "MCX · LME · Live Rates — INR + USD",
    heroTag1: "Specialists in", heroTag2: "and", heroTag3: "— live MCX & LME rates for every metal, in both INR and USD. Two decades of trust.",
    heroViewRates: "View Live Rates",
    ratesTag: "01 — Live Market Watch", live: "Live", feed: "Feed",
    thMetal: "Metal", thMcx: "MCX (₹ INR)", thChange: "Change", thLme: "LME ($ USD)", thUnit: "Unit",
    loadingFeed: "Loading live feed…", star: "Star",
    ratesDisclaimer: "* Indicative rates derived live from international markets + USD/INR. Call for final deal rates — +91 80000 93073",
    shareRates: "Share Today's Rates",
    chartsTag: "03 — Price Movement", chartsTitle1: "Rate", chartsTitle2: "Charts",
    day: "1 Day", week: "1 Week", chartLoading: "Loading chart…", chartNoData: "Data unavailable",
    metalsTag: "04 — Our World", metalsH1: "Copper. Aluminium.", metalsH2: "And Much More.",
    metalsPara: "Copper and Aluminium are our speciality — wholesale and retail. Plus the full range of bullion and base metals. Like a rate? Call us directly.",
    aboutTag: "05 — Manifesto", aboutHeading1: "Trust As Strong", aboutHeading2: "As Metal",
    chapters: [
      { n: "01", title: "Legacy", text: "A journey that began two decades ago from a small shop — today Mahima Metals is another name for trust. Business changed, principles didn't: honesty." },
      { n: "02", title: "Purity", text: "Every tola, every kilo — certified and tested. Speciality in Copper and Aluminium with lab-verified quality. The rate we quote is the quality you get." },
      { n: "03", title: "Reach", text: "Global MCX and LME prices delivered straight to your city — in both INR and USD. Jewellers, industries and traders — one transparent source for all." },
      { n: "04", title: "Vision", text: "Technology meets tradition. Live digital rates, instant updates and the same old trust — that is the identity of Mahima Metals." },
    ],
    locTag: "07 — Our Location", locH1: "Come,", locH2: "Visit Us.",
    address: "Address", timing: "Timing", call: "Call", timingVal: "Mon – Sat · 10:00 AM – 8:00 PM",
    directions: "Get Directions", openMaps: "Open In Google Maps",
    contactTag: "08 — Get In Touch", contactH1: "Let's Talk,", contactH2: "Let's Deal.",
    callAnytime: "Call Anytime", enquiryForm: "Enquiry Form",
    name: "Name", namePh: "Your name", mobile: "Mobile", mobilePh: "10-digit number",
    metal: "Metal", message: "Message", messagePh: "Quantity, rate or any question…",
    send: "Send Enquiry", sending: "Sending…",
    toastOk: "Thank you! Our team will contact you soon.",
    toastErr: "Could not send enquiry. Please call directly — +91 80000 93073",
    footerTagline: "Copper · Aluminium · Trust", rights: "All rights reserved.",
    footerDisclaimer: "Rates are indicative — confirm final prices on call.",
    productsTag: "02 — Our Products", productsH1: "Products That", productsH2: "Build India.",
    productsPara: "Genuine quality, transparent pricing. Every product photographed from our own stock — tap to enquire directly on WhatsApp.",
    enquireWa: "Enquire on WhatsApp",
    copperStoryLine: "Pure. Conductive. Trusted.",
    aluStoryLine: "Light. Strong. Versatile.",
    scrollExplore: "Scroll to explore",
    reviewsTag: "06 — Customer Trust", reviewsH1: "Traders Trust,", reviewsH2: "Mahima Delivers.",
    subH1: "Daily Rates On WhatsApp", subPara: "Leave your number — get today's metal rates on WhatsApp every morning. Free service.",
    subBtn: "Subscribe", subOk: "Subscribed! You will start receiving daily rates soon.", subAlready: "This number is already subscribed.",
    subErr: "Could not subscribe. Please try again or call us.", subPhoneErr: "Please enter a valid 10-digit mobile number.",
  },
  hi: {
    navHome: "होम", navRates: "लाइव रेट", navCharts: "चार्ट", navMetals: "मेटल्स", navProducts: "प्रोडक्ट्स", navLocation: "लोकेशन", navContact: "संपर्क",
    heroBadge: "MCX · LME · लाइव रेट — INR + USD",
    heroTag1: "हमारी स्पेशलिटी:", heroTag2: "और", heroTag3: "— हर मेटल का लाइव MCX और LME रेट, INR और USD दोनों में। दो दशकों का भरोसा।",
    heroViewRates: "लाइव रेट देखें",
    ratesTag: "01 — लाइव मार्केट वॉच", live: "लाइव", feed: "फ़ीड",
    thMetal: "मेटल", thMcx: "MCX (₹ INR)", thChange: "बदलाव", thLme: "LME ($ USD)", thUnit: "यूनिट",
    loadingFeed: "लाइव फ़ीड लोड हो रही है…", star: "खास",
    ratesDisclaimer: "* रेट international market + USD/INR से live convert किए गए indicative भाव हैं। Final रेट के लिए कॉल करें — +91 80000 93073",
    shareRates: "आज के रेट शेयर करें",
    chartsTag: "03 — प्राइस मूवमेंट", chartsTitle1: "रेट", chartsTitle2: "चार्ट",
    day: "1 दिन", week: "1 हफ़्ता", chartLoading: "चार्ट लोड हो रहा है…", chartNoData: "डेटा उपलब्ध नहीं",
    metalsTag: "04 — हमारी दुनिया", metalsH1: "कॉपर. एल्युमिनियम.", metalsH2: "और भी बहुत कुछ.",
    metalsPara: "कॉपर और एल्युमिनियम हमारी स्पेशलिटी है — होलसेल और रिटेल दोनों। साथ में बुलियन और बेस मेटल्स का पूरा रेंज। रेट पसंद आए? सीधा कॉल करें।",
    aboutTag: "05 — मेनिफेस्टो", aboutHeading1: "धातु जैसा", aboutHeading2: "मज़बूत भरोसा",
    chapters: [
      { n: "01", title: "विरासत", text: "दो दशक पहले एक छोटी सी दुकान से शुरू हुआ सफ़र, आज महिमा मेटल्स भरोसे का दूसरा नाम है। व्यापार बदला, पर सिद्धांत वही — ईमानदारी।" },
      { n: "02", title: "शुद्धता", text: "हर तोला, हर किलो — certified और tested। कॉपर और एल्युमिनियम में स्पेशलिटी, lab-verified quality के साथ। जो रेट बोलें, वही quality मिले।" },
      { n: "03", title: "पहुँच", text: "MCX और LME के global भाव सीधा आपके शहर तक — INR और USD दोनों में। ज्वेलर्स, इंडस्ट्रीज़ और ट्रेडर्स — सबके लिए एक ही transparent source।" },
      { n: "04", title: "दृष्टि", text: "Technology और परंपरा का संगम। Live digital rates, instant updates और वही पुराना भरोसा — यही महिमा मेटल्स की पहचान है।" },
    ],
    locTag: "07 — हमारी लोकेशन", locH1: "आइए,", locH2: "मिलिए.",
    address: "पता", timing: "समय", call: "कॉल", timingVal: "सोम – शनि · 10:00 AM – 8:00 PM",
    directions: "डायरेक्शन पाएं", openMaps: "Google Maps में खोलें",
    contactTag: "08 — संपर्क करें", contactH1: "बात करें,", contactH2: "डील करें.",
    callAnytime: "कभी भी कॉल करें", enquiryForm: "पूछताछ फ़ॉर्म",
    name: "नाम", namePh: "आपका नाम", mobile: "मोबाइल", mobilePh: "10-अंकों का नंबर",
    metal: "मेटल", message: "संदेश", messagePh: "मात्रा, रेट या कोई और सवाल…",
    send: "पूछताछ भेजें", sending: "भेज रहे हैं…",
    toastOk: "धन्यवाद! हमारी टीम आपसे जल्द संपर्क करेगी।",
    toastErr: "पूछताछ भेजने में दिक्कत आई। कृपया सीधा कॉल करें — +91 80000 93073",
    footerTagline: "कॉपर · एल्युमिनियम · भरोसा", rights: "सर्वाधिकार सुरक्षित।",
    footerDisclaimer: "रेट indicative हैं — final भाव कॉल पर confirm करें।",
    productsTag: "02 — हमारे प्रोडक्ट्स", productsH1: "प्रोडक्ट्स जो", productsH2: "भारत बनाते हैं.",
    productsPara: "असली quality, transparent pricing। हर product हमारे अपने स्टॉक से — WhatsApp पर सीधे पूछताछ करें।",
    enquireWa: "WhatsApp पर पूछें",
    copperStoryLine: "शुद्ध. Conductive. भरोसेमंद.",
    aluStoryLine: "हल्का. मज़बूत. Versatile.",
    scrollExplore: "स्क्रॉल करें",
    reviewsTag: "06 — ग्राहकों का भरोसा", reviewsH1: "व्यापारियों का भरोसा,", reviewsH2: "महिमा की पहचान.",
    subH1: "रोज़ के रेट WhatsApp पर", subPara: "अपना नंबर छोड़िए — रोज़ सुबह आज के मेटल रेट WhatsApp पर पाइए। बिल्कुल फ्री।",
    subBtn: "सब्सक्राइब करें", subOk: "सब्सक्राइब हो गया! जल्द ही daily rates मिलने शुरू होंगे।", subAlready: "यह नंबर पहले से सब्सक्राइब है।",
    subErr: "सब्सक्राइब नहीं हो पाया। दोबारा कोशिश करें या कॉल करें।", subPhoneErr: "कृपया सही 10-अंकों का मोबाइल नंबर डालें।",
  },
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("mm_lang") || "en");
  const toggle = () => {
    const next = lang === "en" ? "hi" : "en";
    setLang(next);
    localStorage.setItem("mm_lang", next);
  };
  const str = STR[lang];
  return <LangContext.Provider value={{ lang, toggle, str }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
